(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cro-collection-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cro-catalog-filter')) {
    class CroCatalogFilter extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.grid = this.querySelector('[data-grid]');
        this.chips = Array.from(this.querySelectorAll('[data-filter]'));
        this.sortSelect = this.querySelector('[data-sort]');
        if (!this.grid) return;

        for (const chip of this.chips) {
          chip.addEventListener('click', () => this.selectFilter(chip), { signal });
        }
        this.sortSelect?.addEventListener('change', () => this.applySort(), { signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      get cards() {
        return Array.from(this.grid.querySelectorAll(':scope > [data-index]'));
      }

      /** @param {HTMLButtonElement} chip */
      selectFilter(chip) {
        const key = chip.dataset.filter || '';
        for (const other of this.chips) {
          other.setAttribute('aria-pressed', String(other === chip));
        }

        let shown = 0;
        for (const card of this.cards) {
          const tags = (card.dataset.filters || '').split(',');
          const match = key === '' || tags.includes(key);
          card.hidden = !match;
          if (match) shown += 1;
        }

        const empty = this.querySelector('[data-empty]');
        if (empty) empty.hidden = shown > 0;

        const status = this.querySelector('[data-status]');
        if (status) {
          status.textContent =
            shown === 1 ? this.dataset.resultsOne : (this.dataset.resultsOther || '').replace('[count]', String(shown));
        }
      }

      applySort() {
        const mode = this.sortSelect?.value || 'featured';
        const sorted = this.cards.sort((a, b) => {
          if (mode === 'featured') return Number(a.dataset.index) - Number(b.dataset.index);
          const diff = Number(a.dataset.price) - Number(b.dataset.price);
          return mode === 'price-descending' ? -diff : diff;
        });
        for (const card of sorted) this.grid.append(card);
      }
    }

    customElements.define('cro-catalog-filter', CroCatalogFilter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cro-product-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cro-product-hero')) {
    class CroProductHero extends HTMLElement {
      connectedCallback() {
        this.initGallery();
        this.initDeliveryDate();
        this.initVariantPicker();
        this.initStickyBar();
      }

      disconnectedCallback() {
        if (this.stickyObserver) this.stickyObserver.disconnect();
        document.body.classList.remove('cro-sticky-atc-visible');
      }

      initGallery() {
        const thumbs = this.querySelectorAll('[data-thumb]');
        const slides = this.querySelectorAll('[data-slide]');
        thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => {
            const index = thumb.dataset.thumb;
            slides.forEach((slide) => slide.classList.toggle('is-active', slide.dataset.slide === index));
            thumbs.forEach((other) => other.setAttribute('aria-pressed', String(other === thumb)));
          });
        });
      }

      initDeliveryDate() {
        const target = this.querySelector('[data-cro-delivery-date]');
        const min = parseInt(this.dataset.minDays, 10);
        const max = parseInt(this.dataset.maxDays, 10);
        if (!target || Number.isNaN(min) || Number.isNaN(max)) return;

        const start = new Date();
        const end = new Date();
        start.setDate(start.getDate() + Math.min(min, max));
        end.setDate(end.getDate() + Math.max(min, max));
        const month = (date) => date.toLocaleDateString('en-US', { month: 'short' });

        target.textContent =
          start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()
            ? `${month(start)} ${start.getDate()} – ${end.getDate()}`
            : `${month(start)} ${start.getDate()} – ${month(end)} ${end.getDate()}`;
      }

      initVariantPicker() {
        const data = this.querySelector('[data-cro-variants]');
        if (!data) return;
        const variants = JSON.parse(data.textContent);
        const inputs = this.querySelectorAll('[data-option-index]');

        this.addEventListener('change', (event) => {
          if (!event.target.matches('[data-option-index]')) return;
          const selected = [];
          inputs.forEach((input) => {
            if (input.checked) selected[parseInt(input.dataset.optionIndex, 10)] = input.value;
          });
          const variant = variants.find((v) => v.options.every((value, i) => value === selected[i]));
          if (!variant) return;

          this.querySelectorAll('[data-cro-price]').forEach((el) => {
            el.textContent = variant.price;
          });
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        });
      }

      initStickyBar() {
        const bar = this.querySelector('[data-cro-sticky]');
        const cta = this.querySelector('[data-cro-hero-cta]');
        if (!bar || !cta || !('IntersectionObserver' in window)) return;
        const button = bar.querySelector('a');

        this.stickyObserver = new IntersectionObserver(([entry]) => {
          const passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          bar.classList.toggle('is-visible', passed);
          bar.setAttribute('aria-hidden', String(!passed));
          if (button) button.tabIndex = passed ? 0 : -1;
          document.body.classList.toggle('cro-sticky-atc-visible', passed);
        });
        this.stickyObserver.observe(cta);
      }
    }

    customElements.define('cro-product-hero', CroProductHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cro-product-ideas"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cro-product-ideas')) {
    class CroProductIdeas extends HTMLElement {
      connectedCallback() {
        this.dots = Array.from(this.querySelectorAll('.cro-product-ideas__dot'));
        if (!this.dots.length) return;
        this.querySelectorAll('[data-ideas-track]').forEach((track) => {
          track.addEventListener('scroll', () => this.update(track), { passive: true });
        });
      }

      update(track) {
        const card = track.querySelector('.cro-product-ideas__card');
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
        const max = track.scrollWidth - track.clientWidth;
        const count = track.children.length;
        const index = track.scrollLeft >= max - 2 ? count - 1 : Math.round(track.scrollLeft / step);
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === Math.min(index, this.dots.length - 1)));
      }
    }

    customElements.define('cro-product-ideas', CroProductIdeas);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cro-product-journey"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cro-product-journey-slider')) {
    class CroProductJourneySlider extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.pages = Array.from(this.querySelectorAll('[data-page]'));
        this.loop = this.hasAttribute('data-loop');
        this.prevButton = this.querySelector('[data-prev]');
        this.nextButton = this.querySelector('[data-next]');
        this.countEl = this.querySelector('[data-count]');
        this.barEl = this.querySelector('[data-bar]');
        this.index = 0;
        this.prevButton?.addEventListener('click', () => this.go(this.index - 1), { signal });
        this.nextButton?.addEventListener('click', () => this.go(this.index + 1), { signal });
        this.go(0);
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      go(index) {
        const count = this.pages.length;
        if (!count) return;
        this.index = this.loop ? (index + count) % count : Math.min(Math.max(index, 0), count - 1);
        const prevIndex = this.loop ? (this.index - 1 + count) % count : this.index - 1;
        const nextIndex = this.loop ? (this.index + 1) % count : this.index + 1;
        this.pages.forEach((page, i) => {
          page.classList.toggle('is-current', i === this.index);
          page.classList.toggle('is-next', count > 1 && i === nextIndex && i !== this.index);
          page.classList.toggle('is-prev', count > 2 && i === prevIndex && i !== nextIndex);
        });
        if (!this.loop && this.prevButton && this.nextButton) {
          const focused = document.activeElement;
          this.prevButton.disabled = this.index === 0;
          this.nextButton.disabled = this.index === count - 1;
          if (focused === this.prevButton && this.prevButton.disabled) this.nextButton.focus();
          if (focused === this.nextButton && this.nextButton.disabled) this.prevButton.focus();
        }
        if (this.countEl) {
          const template = this.countEl.getAttribute('data-template') || '';
          const label = template.replace('[current]', String(this.index + 1));
          if (this.countEl.textContent.trim() !== label) this.countEl.textContent = label;
        }
        this.barEl?.style.setProperty('--cro-journey-progress', `${((this.index + 1) / count) * 100}%`);
      }
    }

    customElements.define('cro-product-journey-slider', CroProductJourneySlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cro-product-quality"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cro-product-quality-media')) {
    class CroProductQualityMedia extends HTMLElement {
      connectedCallback() {
        const video = this.querySelector('video');
        const button = this.querySelector('[data-play]');
        if (!video || !button) return;
        const toggle = () => {
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
        };
        button.addEventListener('click', toggle);
        video.addEventListener('click', toggle);
        video.addEventListener('play', () => {
          this.classList.add('is-playing');
          button.setAttribute('aria-label', 'Pause video');
        });
        video.addEventListener('pause', () => {
          this.classList.remove('is-playing');
          button.setAttribute('aria-label', 'Play video');
        });
      }
    }

    customElements.define('cro-product-quality-media', CroProductQualityMedia);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cro-product-social"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cro-product-social')) {
    class CroProductSocial extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.tiles = Array.from(this.querySelectorAll('.cro-product-social__tile')).filter((tile) =>
          tile.querySelector('video')
        );
        if (!this.tiles.length) return;

        for (const tile of this.tiles) {
          const video = tile.querySelector('video');
          const toggle = tile.querySelector('[data-social-toggle]');
          video.muted = true;
          video.removeAttribute('controls');
          video.addEventListener('play', () => this.syncToggle(tile), { signal });
          video.addEventListener('pause', () => this.syncToggle(tile), { signal });
          if (toggle) {
            toggle.hidden = false;
            toggle.addEventListener(
              'click',
              () => {
                if (video.paused) {
                  tile.dataset.userPaused = 'false';
                  video.play().catch(() => {});
                } else {
                  tile.dataset.userPaused = 'true';
                  video.pause();
                }
              },
              { signal }
            );
          }
          this.syncToggle(tile);
        }

        if (this.reduceMotion || !('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              const video = entry.target.querySelector('video');
              if (entry.isIntersecting) {
                if (entry.target.dataset.userPaused !== 'true') video.play().catch(() => {});
              } else if (!video.paused) {
                video.pause();
              }
            }
          },
          { threshold: 0.5 }
        );
        for (const tile of this.tiles) this.observer.observe(tile);
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.observer?.disconnect();
      }

      syncToggle(tile) {
        const video = tile.querySelector('video');
        const toggle = tile.querySelector('[data-social-toggle]');
        if (!video || !toggle) return;
        const playing = !video.paused;
        toggle.classList.toggle('is-playing', playing);
        const label = playing ? toggle.dataset.labelPause : toggle.dataset.labelPlay;
        if (label) toggle.setAttribute('aria-label', label);
      }
    }

    customElements.define('cro-product-social', CroProductSocial);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrapbook-photo-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.scrapbook-slider[data-section-id]').forEach(function (root) {
      var id = root.getAttribute('data-section-id');
      var dataEl = document.getElementById('scrapbook-data-' + id);
      if (!dataEl) return;

      var slides;
      try {
        slides = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      if (!slides.length) return;

      var count = slides.length;
      var current = 0;
      var infinite = root.getAttribute('data-slider-loop') !== 'finite';

      var leftSlot = root.querySelector('[data-slot="left"]');
      var centerSlot = root.querySelector('[data-slot="center"]');
      var rightSlot = root.querySelector('[data-slot="right"]');
      var stageEl = root.querySelector('.scrapbook-slider__stage');
      var viewportEl = root.querySelector('.scrapbook-slider__viewport');
      if (!centerSlot || !stageEl || !viewportEl) return;

      function mod(n, m) {
        return ((n % m) + m) % m;
      }

      function updateViewportPadding() {
        /* Narrow: CSS handles vertical padding; inline values were blowing up section height (transform + rect math). */
        if (isNarrowViewport()) {
          viewportEl.style.paddingTop = '';
          viewportEl.style.paddingBottom = '';
          return;
        }

        var polas = stageEl.querySelectorAll('.scrapbook-slider__polaroid');
        if (!polas.length) {
          viewportEl.style.paddingTop = '';
          viewportEl.style.paddingBottom = '';
          return;
        }
        var srect = stageEl.getBoundingClientRect();
        var overflowTop = 0;
        var overflowBottom = 0;
        for (var pi = 0; pi < polas.length; pi++) {
          var r = polas[pi].getBoundingClientRect();
          overflowTop = Math.max(overflowTop, srect.top - r.top);
          overflowBottom = Math.max(overflowBottom, r.bottom - srect.bottom);
        }
        overflowTop = Math.max(0, Math.ceil(overflowTop));
        overflowBottom = Math.max(0, Math.ceil(overflowBottom));
        /* Safety cap — bad layout frames should never add thousands of px of padding. */
        var cap = Math.min(360, Math.round(window.innerHeight * 0.45));
        overflowTop = Math.min(overflowTop, cap);
        overflowBottom = Math.min(overflowBottom, cap);
        viewportEl.style.paddingTop = overflowTop ? overflowTop + 'px' : '';
        viewportEl.style.paddingBottom = overflowBottom ? overflowBottom + 'px' : '';
      }

      function scheduleMeasure() {
        requestAnimationFrame(function () {
          updateViewportPadding();
          requestAnimationFrame(updateViewportPadding);
        });
      }

      function afterImagesLoaded(done) {
        var imgs = stageEl.querySelectorAll('img');
        var pending = 0;
        imgs.forEach(function (img) {
          if (!img.complete) pending++;
        });
        if (pending === 0) {
          done();
          return;
        }
        imgs.forEach(function (img) {
          if (img.complete) return;
          var fin = function () {
            pending--;
            if (pending <= 0) done();
          };
          img.addEventListener('load', fin);
          img.addEventListener('error', fin);
        });
      }

      function buildFigure(slide) {
        var fig = document.createElement('figure');
        fig.className = 'scrapbook-slider__polaroid';
        if (slide.rotation != null) {
          fig.style.setProperty('--slot-rot', slide.rotation + 'deg');
        }
        if (slide.src) {
          var img = document.createElement('img');
          img.src = slide.src;
          img.alt = slide.alt || '';
          img.sizes = '(min-width: 750px) 520px, 88vw';
          if (slide.srcset) img.setAttribute('srcset', slide.srcset);
          img.loading = 'lazy';
          fig.appendChild(img);
        } else {
          var ph = document.createElement('div');
          ph.className = 'scrapbook-slider__placeholder';
          ph.textContent = 'Select an image in the theme editor';
          fig.appendChild(ph);
        }
        return fig;
      }

      function updateNavDisabled() {
        var prevBtn = root.querySelector('.scrapbook-slider__nav--prev');
        var nextBtn = root.querySelector('.scrapbook-slider__nav--next');
        if (!prevBtn || !nextBtn) return;
        if (count <= 1) {
          prevBtn.disabled = true;
          nextBtn.disabled = true;
          return;
        }
        if (infinite) {
          prevBtn.disabled = false;
          nextBtn.disabled = false;
          return;
        }
        prevBtn.disabled = current === 0;
        nextBtn.disabled = current === count - 1;
      }

      function isNarrowViewport() {
        return typeof window.matchMedia === 'function'
          ? window.matchMedia('(max-width: 749px)').matches
          : window.innerWidth <= 749;
      }

      function render() {
        var i = current;
        var iL;
        var iR;
        if (infinite || count === 1) {
          iL = mod(i - 1, count);
          iR = mod(i + 1, count);
        } else {
          iL = i > 0 ? i - 1 : -1;
          iR = i < count - 1 ? i + 1 : -1;
        }

        var narrow = isNarrowViewport();

        leftSlot.innerHTML = '';
        rightSlot.innerHTML = '';
        centerSlot.innerHTML = '';

        if (count === 1) {
          centerSlot.appendChild(buildFigure(slides[0]));
        } else if (narrow) {
          centerSlot.appendChild(buildFigure(slides[i]));
        } else {
          if (iL >= 0) leftSlot.appendChild(buildFigure(slides[iL]));
          centerSlot.appendChild(buildFigure(slides[i]));
          if (iR >= 0) rightSlot.appendChild(buildFigure(slides[iR]));
        }

        updateNavDisabled();
        scheduleMeasure();
        afterImagesLoaded(scheduleMeasure);
      }

      root.querySelectorAll('.scrapbook-slider__nav').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          var dir = parseInt(btn.getAttribute('data-dir'), 10);
          if (count <= 1) return;
          var nextIdx;
          if (infinite) {
            current = mod(current + dir, count);
          } else {
            nextIdx = current + dir;
            if (nextIdx < 0 || nextIdx >= count) return;
            current = nextIdx;
          }
          render();
        });
      });

      var resizeTimer;
      var lastNarrow = isNarrowViewport();
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          var nowNarrow = isNarrowViewport();
          if (nowNarrow !== lastNarrow) {
            lastNarrow = nowNarrow;
            render();
            return;
          }
          scheduleMeasure();
        }, 120);
      });

      render();
    });
  })();

  (function () {
    function fmt(n) {
      return (Math.round(n * 10000) / 10000).toString();
    }

    /**
     * Smooth cosine waves in objectBoundingBox space (y down). Crests at y=0 / y=1; trough depth
     * comes from data-wave-h (px) vs element height — matches the Wave depth theme setting.
     * Two cubic Beziers per half-period (trough↔crest) with horizontal tangents.
     *
     * CRITICAL: clipEl = .scrapbook-slider__surface (for path + getBoundingClientBox). Theme controls are on
     * the ROOT: always use root = clipEl.closest('.scrapbook-slider') for data-wave-period / data-wave-h /
     * data-wave-show-*. Never read attrs from clipEl alone — sliders will appear broken (silent defaults).
     */
    function buildWavePath(clipEl) {
      var root = clipEl.closest('.scrapbook-slider') || clipEl;
      var period = parseFloat(root.getAttribute('data-wave-period'), 10);
      if (isNaN(period) || period < 1) period = 324;
      var wpx = clipEl.offsetWidth || 1;
      var n = Math.round(wpx / period);
      n = Math.max(2, Math.min(96, n));

      var topOn = root.getAttribute('data-wave-show-top') !== '0';
      var botOn = root.getAttribute('data-wave-show-bottom') !== '0';

      var h = clipEl.offsetHeight || 1;
      var wh = parseFloat(root.getAttribute('data-wave-h'), 10);
      if (isNaN(wh) || wh < 1) wh = 36;
      var maxWh = topOn && botOn ? h * 0.48 : h * 0.49;
      wh = Math.max(1, Math.min(wh, maxWh));
      var frac = wh / h;
      var yt = topOn ? frac : 0;
      var yb = botOn ? 1 - frac : 1;

      var i;
      var j;
      var xL;
      var xm;
      var xR;
      var dxh;
      var d;

      function segTopForward() {
        var s = '';
        for (i = 0; i < n; i++) {
          xL = i / n;
          xm = (i + 0.5) / n;
          xR = (i + 1) / n;
          dxh = (xm - xL) / 3;
          s +=
            ' C' +
            fmt(xL + dxh) +
            ',0 ' +
            fmt(xm - dxh) +
            ',' +
            fmt(yt) +
            ' ' +
            fmt(xm) +
            ',' +
            fmt(yt);
          s +=
            ' C' +
            fmt(xm + dxh) +
            ',' +
            fmt(yt) +
            ' ' +
            fmt(xR - dxh) +
            ',0 ' +
            fmt(xR) +
            ',0';
        }
        return s;
      }

      function segTopBackward() {
        var s = '';
        for (i = n - 1; i >= 0; i--) {
          xL = i / n;
          xm = (i + 0.5) / n;
          xR = (i + 1) / n;
          dxh = (xR - xm) / 3;
          s +=
            ' C' +
            fmt(xR - dxh) +
            ',0 ' +
            fmt(xm + dxh) +
            ',' +
            fmt(yt) +
            ' ' +
            fmt(xm) +
            ',' +
            fmt(yt);
          s +=
            ' C' +
            fmt(xm - dxh) +
            ',' +
            fmt(yt) +
            ' ' +
            fmt(xL + dxh) +
            ',0 ' +
            fmt(xL) +
            ',0';
        }
        return s;
      }

      function segBottomForward() {
        var s = '';
        for (j = 0; j < n; j++) {
          xL = j / n;
          xm = (j + 0.5) / n;
          xR = (j + 1) / n;
          dxh = (xm - xL) / 3;
          s +=
            ' C' +
            fmt(xL + dxh) +
            ',1 ' +
            fmt(xm - dxh) +
            ',' +
            fmt(yb) +
            ' ' +
            fmt(xm) +
            ',' +
            fmt(yb);
          s +=
            ' C' +
            fmt(xm + dxh) +
            ',' +
            fmt(yb) +
            ' ' +
            fmt(xR - dxh) +
            ',1 ' +
            fmt(xR) +
            ',1';
        }
        return s;
      }

      function segBottomBackward() {
        var s = '';
        for (j = n - 1; j >= 0; j--) {
          xR = (j + 1) / n;
          xm = (j + 0.5) / n;
          xL = j / n;
          dxh = (xR - xm) / 3;
          s +=
            ' C' +
            fmt(xR - dxh) +
            ',1 ' +
            fmt(xm + dxh) +
            ',' +
            fmt(yb) +
            ' ' +
            fmt(xm) +
            ',' +
            fmt(yb);
          s +=
            ' C' +
            fmt(xm - dxh) +
            ',' +
            fmt(yb) +
            ' ' +
            fmt(xL + dxh) +
            ',1 ' +
            fmt(xL) +
            ',1';
        }
        return s;
      }

      if (topOn && botOn) {
        d = 'M0,1';
        d += segBottomForward();
        d += ' L1,0';
        d += segTopBackward();
        d += ' L0,1 Z';
        return d;
      }

      if (topOn) {
        d = 'M0,1 L0,0';
        d += segTopForward();
        d += ' L1,1 L0,1 Z';
        return d;
      }

      if (botOn) {
        d = 'M0,0 L1,0 L1,1';
        d += segBottomBackward();
        d += ' L0,0 Z';
        return d;
      }

      return 'M0,0 L1,0 L1,1 L0,1 Z';
    }

    function applyWaveClip(clipEl) {
      var path = clipEl.querySelector('.scrapbook-slider__clip-path');
      if (!path) return;
      function run() {
        if (clipEl.offsetWidth < 2) {
          requestAnimationFrame(run);
          return;
        }
        path.setAttribute('d', buildWavePath(clipEl));
      }
      run();
    }

    function initWaves(root) {
      if (!root || !root.classList || !root.classList.contains('scrapbook-slider--waves')) return;
      if (!root.getAttribute('data-wave-period')) return;
      if (root._scrapbookWaveRo) {
        root._scrapbookWaveRo.disconnect();
        root._scrapbookWaveRo = null;
      }
      var surf = root.querySelector('.scrapbook-slider__surface');
      var clipEl = surf || root;
      applyWaveClip(clipEl);
      if (typeof ResizeObserver !== 'undefined') {
        root._scrapbookWaveRo = new ResizeObserver(function () {
          applyWaveClip(clipEl);
        });
        root._scrapbookWaveRo.observe(clipEl);
      } else {
        window.addEventListener('resize', function () {
          applyWaveClip(clipEl);
        });
      }
    }

    document.querySelectorAll('.scrapbook-slider--waves[data-wave-period]').forEach(initWaves);

    document.addEventListener('shopify:section:load', function (ev) {
      if (!ev.target) return;
      ev.target.querySelectorAll('.scrapbook-slider--waves[data-wave-period]').forEach(initWaves);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
